
export default {
  name: "greySection",
  props: ['title', 'img']
}
